import React from 'react'

import { Card, CollapseColumn, Row, Span } from 'components'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

import { TableContract } from './components'
import { tableData } from './mock'
const ReportsContracts: React.FC = () => {
  const mesInicial = '07/2018'
  const mesFinal = '08/2018'
  const reportContracts = ['', '', '']
  return (
    <Card
      marginTop={SPACING.spacing5}
      marginLeft={SPACING.spacing5}
      marginRight={SPACING.spacing5}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
    >
      <Card backgroundColor={COLORS.primary} padding="8px 0">
        <Row alignItems="center" justifyContent="center">
          <Span
            text={`Mes Inicial: ${mesInicial}`}
            marginRight={SPACING.spacing50}
            fontWeight={FONTS.bold}
            fontSize={TYPOGRAPHY.bodySize16}
          />
          <Span
            text={`Mes Final: ${mesFinal}`}
            fontWeight={FONTS.bold}
            fontSize={TYPOGRAPHY.bodySize16}
          />
        </Row>
      </Card>

      {reportContracts?.map((contract, index) => (
        <CollapseColumn
          key={index.toString()}
          nuContrato="4502148994"
          nmFornecedor="QUAKER CHEMICAL INDUSTRIA"
          nmDiretoriaExecutiva="Diretoria Executiva Producao"
          nmDiretoria="Diretoria de Produtos"
          nmGerenciaGeral="Gerencia Geral Lamin Frio"
          nmGerencia="Gerencia de Recozimento"
          index={index}
        >
          <Row alignItems="center" justifyContent="center">
            <Span
              text="MÃO DE OBRA"
              textAlign="center"
              color={COLORS.blueFonts}
              fontSize="24px"
              fontWeight="700"
            />
          </Row>
          <TableContract tableData={tableData} />
        </CollapseColumn>
      ))}
    </Card>
  )
}

export default ReportsContracts
